import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  class: "m-0"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#777e90",
      "fill-rule": "evenodd",
      d: "M20.2 13.8a1 1 0 0 0-1.4 0L16 16.6l-2.8-2.8a1 1 0 0 0-1.4 1.4l3.5 3.5c.4.4 1 .4 1.4 0l3.5-3.5c.4-.4.4-1 0-1.4",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("rect", {
      width: "30",
      height: "30",
      x: "1",
      y: "1",
      stroke: "#e6e8ec",
      "stroke-width": "2",
      rx: "15"
    }, null, -1)
  ]))]))
}
export default { render: render }